
export default {
  book: {
    format: 'a4',
  },
}



// WEBPACK FOOTER //
// ./src/defaults.js